const _ = require('lodash');
const USE_REMOTE = 'USE_REMOTE';
const CURRENT_USER = 'CURRENT_USER';

function StorageService() {

    this.getUseRemote = () => {
      return parseJson(localStorage.getItem(USE_REMOTE));
    };

    this.getCurrentUser = () => {
      return parseJson(localStorage.getItem(CURRENT_USER));
    };

    this.clearUser = () => {
        localStorage.removeItem(CURRENT_USER);
    };

    function parseJson(stringToParse, defaultValue) {
        let result;
        try {
            result = JSON.parse(stringToParse);
        } catch (e) {
            return defaultValue;
        }
        return _.isNull(result) ? defaultValue : result;
    }
}

module.exports = new StorageService();


//////////////////
// WEBPACK FOOTER
// ./form/components/utils/StorageService.js
// module id = 6
// module chunks = 0 1